import TextInput from '../shared/TextInput';
import React from 'react';
import ColorButton from '../shared/ColorButton';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ReorderDotsVerticalIcon from '../../assets/icons/ReorderDotsVerticalIcon';

const PipelineStageForm = (props) => {
  const { id, stage, onChange, onDeleteClick, isLost } = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    setActivatorNodeRef
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition ?? 'transform 50ms ease',
  };

  return (
    <div className='sales-page__stage-item stage-item-form__container draggable' ref={setNodeRef} style={style}>
      <div className="stage-item-form__header">
        <div
          className="drag-handle"
          ref={setActivatorNodeRef}
          {...attributes}
          {...listeners}
        >
          <ReorderDotsVerticalIcon color='#5f6368' fontSize='small' />
        </div>
      </div>
      <div className='stage-item-form'>
        <div>
          <div>
            <div className='secondary m-b-sm'>Title</div>
            <TextInput
              value={stage.title}
              onChange={(e) => onChange('title', e.target.value)}
              placeholder='Type title here'
            />
          </div>
          <div className='m-t-md'>
            <div className='secondary m-b-sm'>Description</div>
            <TextInput
              value={stage.description}
              onChange={(e) => onChange('description', e.target.value)}
              placeholder='Type description here'
            />
          </div>
          <div className='m-t-md'>
            <div className='secondary m-b-sm'>Probability (%)</div>
            <TextInput
              value={stage.probability}
              onChange={(e) => onChange('probability', e.target.value)}
              type='number'
            />
          </div>
          {!isLost && (
            <div className='m-t-md m-b-md'>
              <div className='secondary m-b-sm'>Rotting Period (days)</div>
              <TextInput
                value={stage.rottingPeriod}
                onChange={(e) => onChange('rottingPeriod', e.target.value)}
                type='number'
              />
            </div>
          )}
        </div>

        <ColorButton
          text='Delete Stage'
          color='red'
          onClick={onDeleteClick}
          height={40}
        />
      </div>
    </div>
  );
};

export default PipelineStageForm;